/* eslint-disable import/first */
import React, { useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Button } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import DialogContent from '@material-ui/core/DialogContent';
import DrawerPwa from '../../../components/DrawerPwa';
import DialogBox from '../../../components/DialogBox';
// import { Badge } from '../../../components/Icons';
import css from '../index.module.scss';
import { useNavigate } from '@reach/router';

// TODO: Verify what is the mechanism to show the defaultchecked status of options
// TODO: Verify what decides when to show this component
// TODO: Send this data in cart and order
export default function ReviewCartPopUp({
  setReviewPopUp,
  isDesktop,
  errorMsg,
  reviewCart = null,
}) {
  const navigate = useNavigate();
  const intl = useIntl();
  // const dispatch = useDispatch();
  // eslint:fix intl and disptach is defined but never used
  const dismissPopup = () => {
    setReviewPopUp(false);
  };
  const navigateToCart = () => {
    navigate(`/${intl.locale}/cart`);
    setReviewPopUp(false);
  };

  const renderInnerPopUp = () => {
    return (
      <DialogContent dividers={true}>
        <div className={css.reviewCart}>
          <div className={css.errorHeading}>
            <FormattedMessage id="noproduct_noitemtext" />
          </div>

          <p>
            {errorMsg && errorMsg !== '' ? (
              errorMsg
            ) : (
              <FormattedMessage id="cartReviewPopUp" default="Review Cart"></FormattedMessage>
            )}
          </p>
          <div className={css.buttons}>
            <Button onClick={dismissPopup} variant="outlined" color="primary" className={css.close}>
              <FormattedMessage
                id="cartDismiss"
                default="The pricing or availability of one or more items in your cart may have changed. Please modify your cart in order to continue."
              />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={navigateToCart}
              className={css.submit}
            >
              <FormattedMessage id="checkout_reviewcart" default="Review Cart" />
            </Button>
          </div>
        </div>
      </DialogContent>
    );
  };
  return (
    <React.Fragment>
      {!isDesktop ? (
        <DrawerPwa
          hideCloseButton={true}
          variant="temporary"
          anchor="bottom"
          open={true}
          className={css.nobg}
          onClose={dismissPopup}
        >
          {renderInnerPopUp()}
        </DrawerPwa>
      ) : (
        <DialogBox hideCloseButton={true} size="sm" isOpen={true} onClose={dismissPopup}>
          {renderInnerPopUp()}
        </DialogBox>
      )}
    </React.Fragment>
  );
}
